// src/components/Header.js
import React from 'react';
import '../styles/components/Header.scss';

const Header = () => {
  return (
    <header className="header">
      {/* This can be empty or used for top banner if needed */}
    </header>
  );
};

export default Header;